<div class="col-xs-8 col-md-8 col-centered col-slider no-padding row">
  <employee-form
    *ngIf="employee.isLoaded"
    [employee]="employee"
    [freighter]="freighter"
    (back)="onBackToList()"
    (saved)="onSaved()"
  ></employee-form>
</div>
